import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Container } from '@ui';
import { SkeletonButton } from '@ui/buttons';
import { uploadStatusActions } from '@constants/actionTypes';

// The icon rides inside the shared button rather than the button being redrawn around it.
const ButtonWrapper = styled.div`
  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    padding: 8px 12px;
  }

  svg {
    height: 16px;
    width: 16px;

    path {
      fill: ${({ theme }) => theme.themeColors.primaryCtaButton};
    }
  }
`;

const RefreshIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M17.65,6.35C16.2,4.9 14.21,4 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20C15.73,20 18.84,17.45 19.73,14H17.65C16.83,16.33 14.61,18 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6C13.66,6 15.14,6.69 16.22,7.78L13,11H20V4L17.65,6.35Z" />
  </svg>
);

/*
  Documents finish processing after the list was fetched, so the vault would otherwise look stale
  until a reload. Mirrors the affordance on Document Management, including clearing the badge.
*/
export const RefreshNewDocsButton = ({ count, onRefreshDocs }) => {
  const dispatch = useDispatch();

  if (!count) return null;

  const handleClick = () => {
    onRefreshDocs();
    dispatch({ type: uploadStatusActions.clearNewlyCompletedUploadDocsCount });
  };

  return (
    <Container bottom={12}>
      <ButtonWrapper>
        <SkeletonButton onClick={handleClick}>
          <RefreshIcon />
          Load {count} newly processed {count === 1 ? 'document' : 'documents'}
        </SkeletonButton>
      </ButtonWrapper>
    </Container>
  );
};
